export const concatIfNotExists = (array, value) => (array.includes(value) ? array : array.concat(value));
